var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"link","to":_vm.to}},[_c('fa',{staticClass:"mr-1",attrs:{"icon":"chevron-left","title":_vm.label ? null : _vm.$t('Back')}}),_vm._v(" "),(_vm.label)?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }